import { Box, Image } from "@chakra-ui/react";
import imgContent from "../../../assets/images/content/bg/content-api.png";
import tContent from "../../../assets/images/content/bg/content-tablet-api.png";
import mContent from "../../../assets/images/content/bg/content-mobile-api.png";

import { useContext } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";


const APITest = () => {
  const screen = useContext(ScreenContext).style;
  const contents = {
    pc: imgContent,
    mobile: mContent,
    tablet: tContent,
  };

  return (
    <Box w={"100%"}>
      <Image 
        src={contents[screen]} 
        w={"100%"} 
        alt="" 
      />
    </Box>
  );
};

export default APITest;